import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { ResultsComponent } from './results/results.component';

import { AuthGuard } from './common/guards/auth.guard';
import { ApiService } from './common/services/api.service';
import { UtilsService } from './common/services/utils.service';
import { AuthService } from './common/services/auth.service';
import { WindowService } from './common/services/window.service';
import { StorageService } from './common/services/storage.service';

import { BrowserWindowRef  } from './common/services/window.service2';

import { AppRoutingModule } from './app.routing.module';

import { DxSelectBoxModule, DxDataGridModule,
          DxListModule,
          DxTemplateModule,
          DxButtonGroupModule,
        DxTextBoxModule, DxPopupModule, DxNumberBoxModule, DxDrawerModule, DxTextAreaModule, DxCheckBoxModule  } from 'devextreme-angular';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ClickOutsideModule } from 'ng4-click-outside';
import { NgxCaptchaModule } from 'ngx-captcha';

import { RequestComponent } from './request/request.component';
import { PublicComponent } from './common/layouts/public/public.component';
import { SecureComponent } from './common/layouts/secure/secure.component';
import { LogoutComponent } from './logout/logout.component';
import { PasswordReminderComponent } from './password-reminder/password-reminder.component';
import { GuestComponent } from './guest/guest.component';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { OurDiamondsComponent } from './our-diamonds/our-diamonds.component';
import { The4csComponent } from './the4cs/the4cs.component';
import { ContactComponent } from './contact/contact.component';
import { TestComponent } from './test/test.component';
import { UpcomingEventsComponent } from './upcoming-events/upcoming-events.component';

import { CookieService } from 'ngx-cookie-service';
import { Results2Component } from './results2/results2.component';

@NgModule({
  declarations: [
    AppComponent,
    ResultsComponent,
    LoginComponent,
    RegisterComponent,
    RequestComponent,
    PublicComponent,
    SecureComponent,
    LogoutComponent,
    PasswordReminderComponent,
    GuestComponent,
    HomeComponent,
    AboutComponent,
    OurDiamondsComponent,
    The4csComponent,
    ContactComponent,
    TestComponent,
    UpcomingEventsComponent,
    Results2Component
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    BrowserAnimationsModule,
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    DxSelectBoxModule,
    DxDataGridModule,
    DxListModule,
    DxTemplateModule,
    DxButtonGroupModule,
    DxTextBoxModule,
    DxPopupModule,
    DxNumberBoxModule,
    DxDrawerModule,
    DxTextAreaModule,
    DxCheckBoxModule,
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    ClickOutsideModule,
    NgxCaptchaModule
  ],
  providers: [
    AuthGuard,
    ApiService,
    AuthService,
    UtilsService,
    WindowService,
    StorageService,
    BrowserWindowRef,
    CookieService
  ],
  bootstrap: [AppComponent],
  exports: [BsDropdownModule, TooltipModule, ModalModule]
})
export class AppModule { }
